import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ButtonData } from '../buttons/buttons.component';

export interface PrevServiceData {
  buttons: Array<ButtonData>;
  categories: string;
  highlightColor: string;
  description: string;
  heightImg: string;
  icons: Array<{
    image: string;
    title: string;
    modal?: any;
    url: string;
    page: string;
  }>;
  image: string;
  subtitle: string;
  tips: Array<{ description: string }>;
  title: string;
  links: Array<Link>;
  imgFirst?: any;
  marginBottom?: any;
}

export interface Link {
  title: string;
  page: string;
  modal: string;
}

@Component({
  selector: 'fcp-prev-service',
  templateUrl: './prev-service.component.html',
  styleUrls: ['./prev-service.component.scss']
})
export class PrevServiceComponent {
  @Input() public column: boolean;
  @Input() public imgFirst: boolean;
  @Input() public prevService: PrevServiceData;
  @Output() public wasButtonClicked: EventEmitter<any> = new EventEmitter();
  @Output() public wasLinkClicked: EventEmitter<Link> = new EventEmitter();
  @Output() public wasClickedScrollToElement: EventEmitter<
    any
  > = new EventEmitter();

  public checkClick($event): void {
    $event.button.target
      ? this.scrollToElementEmitClick($event.button.target)
      : this.emitClick($event);
  }

  public clickLink(link: Link): void {
    if (link) {
      this.wasLinkClicked.emit(link);
    }
  }

  public emitClick(button: any): void {
    if (button) {
      this.wasButtonClicked.emit(button);
    }
  }

  public scrollToElementEmitClick(target): void {
    if (target) {
      this.wasClickedScrollToElement.emit(target);
    }
  }
}
